import {useState, useEffect, useRef} from 'react';

export default (initialValue:any) => {
    const callbackRef = useRef(null);
  
    const [value, setValue] = useState(initialValue);
  
    useEffect(() => {
        if (callbackRef.current) {
            callbackRef.current(value);

            callbackRef.current = null;
        }
    }, [value]);
  
    const setValueWithCallback = (newValue:any, callback:any) => {
        callbackRef.current = callback;

        return setValue(newValue);
    };
  
    return [value, setValueWithCallback];
};